import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const GroupSequencer = ({group, trackStep}) => { 
    const [stepToState, setStepToState] = useState(group.stepToState);
    const [selectedStep, setSelectedStep] = useState(undefined);
    const [enabled, setEnabled] = useState(group.sequencerEnabled);

    useEffect(() => {
        setStepToState(group.stepToState);
    }, [group.stepToState, setStepToState]);

    useEffect(() => {
        return () => group.unselectStep()
    }, [group]);

    const toggleSequencer = useCallback(() => {
        group.sequencerEnabled = !enabled;
        setEnabled(!enabled);
    }, [group, setEnabled, enabled]);

    const onClick = useCallback((e, step, toggle) => {
        if (e.metaKey) {
            // select the step
            group.selectStep(step);
            setSelectedStep(step);
            return;
        }

        if (toggle) {
            group.recordStateAtStep(step);
        } else {
            group.deleteStateAtStep(step);
        }
        setStepToState({... group.stepToState});
        setSelectedStep(undefined);
    }, [setStepToState, group, setSelectedStep]);

    let arr = new Array(16).fill(0);

    let step = Math.floor(trackStep / 2) % 16;
    return (
        <div className="group-sequencer">
          <div className="sequencer-toolbar">
            <div
              className="sequencer-label">
              Sequencer
            </div>
            <div
              onClick={toggleSequencer}
              className={enabled ? "s-stop" : "s-play"}/>
          </div>
          <div className={!enabled ? "sequencer-steps disabled" : "sequencer-steps"}>
            {arr.map(
                (x,i) => <Step
                           isSelected={selectedStep === i}
                           isCurrent={enabled && i === step}
                           onClick={onClick}
                           step={i}
                           hasState={stepToState[i]}
                           group={group}/>)}
          </div>
        </div>
    );
}

const Step = ({step, hasState, group, onClick, isCurrent, isSelected}) => {
    let className = "sequencer-step";
    if (hasState) {
        className += " on";
    }
    if (isCurrent) {
        className += " current";
    }

    if (isSelected) {
        className += " selected";
    }
    return (
        <div onClick={(e) => onClick(e, step, !hasState)} className={className}>
          {step + 1}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      trackStep: props.sequencerEngine.trackStep
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupSequencer);
